export * from './screen-readers-page-title';
